module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_15.81821ed1.png";